import { DescribeProperty } from '../../common';

export class AnnotationDeleteResponse {
  @DescribeProperty({ description: 'The number of entries affected', type: 'number' })
  affected: number;
}
